import React from "react";
import { Link } from "react-router-dom";

const AboutArea = () => {
  return (
    <section className="about-area">
      <div className="container custom-container">
        <div className="about-inner">
          <div className="row align-items-center justify-content-center">
            <div className="col-46 order-0 order-lg-2">
              <div className="about-img text-end">
                <img src="/img/images/about_img.jpg" alt="Professionele stoffeerder herstoffeert bureaustoel met duurzame materialen" />
              </div>
            </div>
            <div className="col-54">
              <div className="about-content">
                <div className="section-title mb-25">
                  <span className="sub-title">Over Ons</span>
                  <h2 className="title">
                    Vakmanschap in Meubelstoffering en Herstoffering
                  </h2>
                </div>
                <p>
                  Wij geven uw meubels een nieuw leven met ambachtelijk vakwerk,
                  duurzame materialen en oog voor detail. Of het nu gaat om banken,
                  fauteuils of projectinrichting, wij leveren kwaliteit die jarenlang meegaat.
                </p>
                <ul className="list-wrap">
                  <li>
                    <div className="icon">
                      <img src="/img/icon/about_icon01.png" alt="Icoon van herstofferen van banken, stoelen en fauteuils" />
                    </div>
                    <div className="content">
                      <h4 className="title">Meubel Herstoffering</h4>
                      <p>
                        Expertise in het herstofferen van banken, stoelen en fauteuils met hoogwaardige stoffen en materialen.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <img src="/img/icon/about_icon02.png" alt="Icoon van projectstoffering voor kantoren en horeca" />
                    </div>
                    <div className="content">
                      <h4 className="title">Projectstoffering</h4>
                      <p>
                        Complete stoffering van bedrijfsruimtes, horeca en kantoren.
                        Afgestemd op maatwerk en duurzaamheid.
                      </p>
                    </div>
                  </li>
                </ul>

                <div className="about-content-bottom">
                  <span>Ontdek meer over onze passie voor stoffering</span>
                  <div className="read-more-btn">
                    <Link to="/about-us" className="btn">
                      Lees Meer <span></span>
                    </Link>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutArea;
